import { onMounted, reactive, ref } from "vue";
import { errManager, showNotification } from "@/core/config/Tools"
import GlobalService from "@/core/services/GlobalService";
import JwtService from "@/core/services/JwtService";
import { useRoute } from "vue-router";

export function usePublicInstitution() {
    const loading = ref(false);
    const route = useRoute();
    const steps = ref(1);
    const dataCompany = ref<any>({});
    const formRef = ref();
    const form = reactive({
        category: '',
        birthday: ''
    });
    const resRegister = ref<any>({});
    const listCountries = ref<any[]>([])

    const getCompany = async () => {
        loading.value = true
        await GlobalService.get(`public/company/${route.params.company}`, 'show')
            .then((res) => {
                dataCompany.value = res.data
                JwtService.saveCompany(res.data?.alias)
                loading.value = false
            }).catch(({ response }) => {
                loading.value = false;
                errManager(response);
            });
    };

    const getCountry = async () =>{
        await GlobalService.get(`public`, 'countries')
        .then((res) => {
            listCountries.value = res.data
        }).catch(({ response }) => {
            errManager(response);
        });
    }

    const getDocuments = async () => {
        //await GlobalService.get('public/catalogue', )
    }

    const nextStep = async () => {
        if(!formRef.value) return;

        const valid = await formRef.value.validate((ok:boolean) => ok);
        if(!valid) return;

        if (steps.value < 3){
            steps.value++;
        } else {
            await submitForm();
        }
    };

    const prevStep = () => {
        if(steps.value > 1) steps.value--;
    }

    const submitForm = () => {
        loading.value = true;
        GlobalService.post('signup', form, 'public')
        .then((res)=>{
            loading.value = false;
            resRegister.value = res.data;
            if(res.data.status != 'success'){
                showNotification(res.data);
            }
        }).catch(({response})=>{
            loading.value = false;
            errManager(response);
        });
    }

    onMounted(()=>{
        getCompany();
        getCountry();
    })

    return {
        loading,
        steps,
        dataCompany,
        formRef,
        form,
        resRegister,
        listCountries,
        //events
        nextStep,
        prevStep,
        getCompany
    }
}